import React, { useEffect, useState } from 'react';
import { listVideos } from '../api';

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { listVideos().then(setVideos).catch(() => {}); }, []);

  return (
    <div className="pt-28 pb-24 min-h-screen">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-12">
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-3">Watch · Learn · Grow</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">Video Hub</h1>
          <div className="gold-divider mt-4" />
          <p className="font-cormorant text-xl text-[#f5ecd9]/70 max-w-2xl mx-auto mt-5">Rituals, tutorials, and wellness guidance from Prestige Elements.</p>
        </div>
        {videos.length === 0 ? (
          <p className="text-center font-cormorant text-xl text-[#f5ecd9]/50">Videos coming soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((v) => (
              <div key={v.id} data-testid={`video-card-${v.id}`} className="card-glass rounded-2xl overflow-hidden cursor-pointer group" onClick={() => setActive(v)}>
                <div className="relative">
                  <img src={`https://img.youtube.com/vi/${v.youtube_id}/hqdefault.jpg`} alt={v.title} className="w-full h-44 object-cover group-hover:opacity-80 transition-opacity" />
                  <div className="absolute inset-0 flex items-center justify-center"><div className="h-14 w-14 rounded-full bg-[#0a0708]/70 border border-[#f0d582]/50 flex items-center justify-center"><div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[14px] border-l-[#f0d582] border-b-[8px] border-b-transparent ml-1" /></div></div>
                  {v.featured && <span className="absolute top-3 left-3 text-[9px] uppercase tracking-widest bg-[#ff4da6] text-white px-2 py-0.5 rounded-full">Featured</span>}
                </div>
                <div className="p-4"><p className="font-jost text-[10px] uppercase tracking-widest text-[#f5ecd9]/40">{v.category}</p><h3 className="font-cinzel text-lg text-[#f5ecd9] mt-1">{v.title}</h3></div>
              </div>
            ))}
          </div>
        )}
      </div>
      {active && (
        <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="video-modal">
          <div className="w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <div className="relative pb-[56.25%] h-0 rounded-xl overflow-hidden">
              <iframe title={active.title} className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
            <p className="font-cinzel text-lg text-[#f0d582] mt-3">{active.title}</p>
            {active.description && <p className="font-cormorant text-lg text-[#f5ecd9]/70 mt-1">{active.description}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Videos;
